export default __webpack_public_path__ + "static/hive-3b21af61972fdf9ac6c6e324cc45deb5.png";